import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import { User } from '@core/objects/user';
import { Message } from '@core/objects/message';
import { VersionFeedbackMessage } from '@core/models/version-feedback-message';

@Component({
    selector: 'plugin-share-feedback-core-version-approval-message-list',
    templateUrl: './version-approval-message-list.component.html',
    styleUrls: ['./version-approval-message-list.component.scss']
})
export class PluginShareFeedbackCoreVersionsMessageResponseListComponent implements OnInit, OnChanges {

    @Input() messages: Array<VersionFeedbackMessage>;
    @Input() user: User;
    @Input() notesActionText: string;
    @Input() notesActionStyle: string;
    @Input() canCreateNotes: boolean = true;
    @Input() canDelete: boolean = true; // messages
    @Input() prefixUrl: string = '';

    @Output() onDelete: EventEmitter<Message> = new EventEmitter<Message>();

    public messagesList: Array<VersionFeedbackMessage> = [];
    constructor() { }

    ngOnInit() {
        // this.loadMessageList();
        console.log(" CAN create notesssssss ",this.canCreateNotes);
        console.log(" messages ",this.messages);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.messages){
            this.messagesList = this.messages;
        }
    }

}
